const posts = [
  {
    title: 'How to Source Steel from China: A Complete Buyer\'s Guide',
    img: 'https://readdy.ai/api/search-image?query=steel%20sourcing%20China%20port%20shipping%20containers%20logistics%20professional&width=600&height=400&seq=blog-steelink-1&orientation=landscape',
    tag: 'Sourcing Guide',
    href: '#',
  },
  {
    title: 'Understanding Mill Test Certificates for Steel Products',
    img: 'https://readdy.ai/api/search-image?query=steel%20quality%20inspection%20testing%20laboratory%20professional%20industrial&width=600&height=400&seq=blog-steelink-2&orientation=landscape',
    tag: 'Quality & Certs',
    href: '#',
  },
  {
    title: 'Hot-Rolled vs Cold-Rolled Steel: Which Do You Need?',
    img: 'https://readdy.ai/api/search-image?query=hot%20rolled%20cold%20rolled%20steel%20coil%20comparison%20industrial%20product&width=600&height=400&seq=blog-steelink-3&orientation=landscape',
    tag: 'Product Guide',
    href: '#',
  },
];

export default function BlogSection() {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-[1420px] mx-auto px-6">
        <div className="text-center lg:text-left">
          <span className="text-xs font-bold tracking-widest uppercase mb-2 block" style={{ color: '#0a2342' }}>Resources</span>
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-3">Steel Insights</h2>
          <p className="text-gray-600 text-sm mb-10 max-w-2xl mx-auto lg:mx-0">
            Practical guides and industry knowledge to help you make smarter steel purchasing decisions.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
          {posts.map((post) => (
            <a
              key={post.title}
              href={post.href}
              className="group block bg-white rounded-lg overflow-hidden border border-gray-100 transition-all cursor-pointer"
              onMouseEnter={(e) => { (e.currentTarget as HTMLElement).style.borderColor = '#1e5fa8'; }}
              onMouseLeave={(e) => { (e.currentTarget as HTMLElement).style.borderColor = '#f3f4f6'; }}
            >
              <div className="w-full h-[200px] overflow-hidden relative">
                <img
                  src={post.img}
                  alt={post.title}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-300"
                />
                <span className="absolute top-3 left-3 text-white text-xs font-bold px-2.5 py-1 rounded-full" style={{ backgroundColor: '#0a2342' }}>
                  {post.tag}
                </span>
              </div>
              <div className="p-5 flex items-start justify-between gap-3">
                <h4 className="text-sm font-bold text-gray-800 group-hover:text-blue-900 transition-colors leading-snug">{post.title}</h4>
                <i className="ri-arrow-right-line flex-shrink-0 mt-0.5" style={{ color: '#0a2342' }} />
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
